import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    ctaRoot: {
      padding: "5px 20px",
      borderRadius: "20px",
      background: "linear-gradient(to right, #FC5003, #CCBB27)",
    },
    ctaLabel: {
      fontSize: "16px",
      fontWeight: "bold",
      color: "white",
    },
  }),
);

const useAppButton = (isCta: boolean, path: string, onClick?: any) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => {
    if (isCta) {
      return {
        button: {
          root: styles.ctaRoot,
          label: styles.ctaLabel,
        },
      };
    }

    return {};
  }, [isCta, styles]);
  const atomicStyles = useAtomicStyles();
  const history = useHistory();

  const onCtaClicked = useMemo(
    () => (path ? () => history.push(path) : onClick),
    [path, history, onClick],
  );

  return {
    styles,
    classes,
    atomicStyles,
    onCtaClicked,
  };
};

export { useAppButton as default };
